import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { BACKEND_URL } from "../constants";
import { normalizeRole } from "../permissions/rolePermissions"; // ✅ FIX

// Create an AuthContext to provide authentication state
const AuthContext = createContext();

// Custom hook to access the AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};

// AuthProvider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState({});
  const [employees, setEmployees] = useState({});
  const [projects, setProjects] = useState({});
  const [customers, setCustomers] = useState({});
  const [draftSchedule, setDraftSchedule] = useState({});
  const [usersHours, setUsersHours] = useState({});
  const [pays, setPays] = useState({});
  const [obs, setObs] = useState({});
  const [salaryProfiles, setSalaryProfiles] = useState({});
  const [timeSchemas, setTimeSchemas] = useState({});
  const [mostRecentTimeSchema, setMostRecentTimeSchema] = useState({});
  const [overtimeRules, setOvertimeRules] = useState({});
  const [vacationPay, setVacationPay] = useState({});
  const [absenceRules, setAbsenceRules] = useState({});
  const [projectGroups, setProjectGroups] = useState({});
  const [reports, setReports] = useState({})
  const [reportCategories, setReportCategories] = useState({})

  const [obUpdateInfo, setObUpdateInfo] = useState({
    companyId: null,
    startedAt: null,
    status: "idle",
    isUpdating: false,
    progress: 0,
    total: 0,
    mode: "idle",
  });

  const [loading, setLoading] = useState(true);

  // Check if the user is logged in by validating cookies/tokens with the backend
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const { data } = await axios.get(
          `${BACKEND_URL}/web/check-auth`,
          { withCredentials: true }
        );

        if (data.status === "success") {

          
          setUser(
            data.user
          );
          console.log("data.user --> ", data.user)
          console.log("user --> ", user)


          setCompany(data.company);
          setEmployees(data.employees);
          setProjects(data.projects);
          setCustomers(data.customers);
          setDraftSchedule(data.shifts);
          setUsersHours(data.usersHours);
          setPays(data.pays);
          setObs(data.obs);
          setOvertimeRules(data.overtimeRules);
          setVacationPay(data.vacationPay);
          setAbsenceRules(data.absenceRules);
          setSalaryProfiles(data.salaryProfiles);
          setTimeSchemas(data.timeSchemas);
          setProjectGroups(data.projectGroups);
          setReports(data.reports);
          setReportCategories(data.reportCategories);
          setMostRecentTimeSchema(data.mostRecentTimeSchema);

          if (data.company?.isOBUpdateActive) {
            setObUpdateInfo({
              isUpdating: true,
              status: "preparing",
              progress: 0,
              total: 0,
              companyId: data.company._id,
              startedAt: Date.now(),
              mode: "resumed",
            });
          }
        } else {
          setUser(null);
        }
      } catch (error) {
        console.log("USER_NOT_FOUND");
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        company,
        setCompany,
        employees,
        setEmployees,
        projects,
        setProjects,
        customers,
        setCustomers,
        draftSchedule,
        setDraftSchedule,
        usersHours,
        setUsersHours,
        pays,
        setPays,
        salaryProfiles,
        setSalaryProfiles,
        obs,
        setObs,
        overtimeRules,
        setOvertimeRules,
        vacationPay,
        setVacationPay,
        absenceRules,
        setAbsenceRules,
        timeSchemas,
        setTimeSchemas,
        mostRecentTimeSchema,
        setMostRecentTimeSchema,
        projectGroups,
        setProjectGroups,
        isAuthenticated,
        loading,
        setLoading,
        obUpdateInfo,
        setObUpdateInfo,
        reports,
        setReports,
        reportCategories,
        setReportCategories,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
